import store from "../../../../../../../../store";
import {setSQFTActiveShapeId} from "../../../../../../../../actions/sqftMenuFunctions";
import {CABINET_BOXES} from "../../../../../../constants";
import {
  reloadCountertopsIn3DMode,
  reloadShapesIn3DMode,
} from "../../../../../../helpers/3dHelper/modelsHelper";
import {renderErrorPopup} from "../../../../../../../../api/api-popups";
import {reportNonFatalError} from "../../../../../../../../misc/errorReporting/errorReporter";
import cabinetWorkspace from "../../../../../canvas/core/cabinet/cabinetWorkspace";
import workspace from "../../../../../canvas/core/workspace";
import sqftShapeManager from "../../../../../canvas/store/sqftShapeManager";
import sqftShapeIntersectionsManager from "../../../../../canvas/store/sqftShapeIntersectionsManager";
import workspaceControllers from "../../../../../canvas/store/workspaceControllers";
import SqftStore from "../../../../../canvas/store/sqftStore";
import {is3DMode} from "../../../../NavigationHelper";

const CABINET_ADD_GAP = 0;

const getBoundsPosition = (bounds) => {
  if (!bounds) {
    return null;
  }

  return {
    x: bounds.right + CABINET_ADD_GAP,
    y: bounds.top
  };
};

const getShapesBounds = (shapes) => {
  const points = sqftShapeManager.getMinMaxShapesPointsOnWorkspace(shapes, true);

  if (!points.length) {
    return null;
  }

  return {
    left: points[0].x,
    top: points[0].y,
    right: points[2].x,
    bottom: points[2].y
  };
};

const getCabinetPlacementPosition = (partId) => {
  const {sqftMenuState} = store.getState();
  const activeShape = workspace.getShapeById(sqftMenuState.sqftActiveShapeId);

  if (activeShape && CABINET_BOXES.includes(activeShape.partId)) {
    return getBoundsPosition(sqftShapeManager.getShapeBoundsOnWorkspace(activeShape, true));
  }

  const cabinetShapes = workspace.getShapes()
    .filter(shape => CABINET_BOXES.includes(shape.partId));

  const samePartCabinetShapes = cabinetShapes.filter(shape => shape.partId === partId);
  const placementTargets = samePartCabinetShapes.length ? samePartCabinetShapes : cabinetShapes;

  return getBoundsPosition(getShapesBounds(placementTargets));
};

const showUnavailableCabinetModelPopup = () => {
  renderErrorPopup('messageBox.cabinet3dModelUnavailable');
};

const removeFailedCabinetShape = (shape) => {
  if (!shape) {
    return;
  }

  sqftShapeManager.removeShapeById(shape.id);
  sqftShapeIntersectionsManager.updateShapesIntersections();
  workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);
  SqftStore.updateCalculations();
};

// In 3D, cabinet clicks should add near the current cabinet run instead of the hidden 2D viewport center.
export const addCabinetShapeToWorkspace = async (feature, parentFeature, options = {}) => {
  const isThreeDMode = is3DMode();
  const position = options.position !== undefined
    ? options.position
    : isThreeDMode
    ? getCabinetPlacementPosition(feature.partId)
    : null;
  const shapeId = cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature, position);
  const shape = workspace.getShapeById(shapeId);

  if (!shape) {
    return null;
  }

  // Active shape id drives the selected cabinet state for menus and edit controls.
  const shouldActivateShape = options.shouldActivateShape !== undefined
    ? options.shouldActivateShape
    : !isThreeDMode;

  if (shouldActivateShape) {
    store.dispatch(setSQFTActiveShapeId(shapeId));
  }

  if (isThreeDMode && options.shouldReloadIn3D !== false) {
    try {
      await reloadShapesIn3DMode([shape]);
      await reloadCountertopsIn3DMode([shape]);
    } catch (error) {
      reportNonFatalError('sqft-3d-cabinet-click-add-model-unavailable', error, {
        shapeId,
        featureId: feature.id,
        parentFeatureId: parentFeature.id,
      });
      removeFailedCabinetShape(shape);
      showUnavailableCabinetModelPopup();
      return null;
    }
  }

  return shape;
};
